import React, {useState} from 'react';
import {detectLanguage} from "../API/OpenAIAPI.js";
import {VolumeUp} from "@mui/icons-material";
import {CircularProgress, IconButton} from "@mui/material";
import {APIRequest} from "../API/APIRequest.js";
import {signKBTransactionJWT} from "../Crypto/utils";
import {MyServices} from "../constants";

export const languageToLocaleMap = {
    "en": "en-US",   // English -> US English
    "mk": "bg-BG",   // MK not supported by Google
    "bg": "bg-BG",   // Bulgarian -> Bulgaria
    "es": "es-ES",   // Spanish -> Spain Spanish (could also be es-MX for Mexico, etc.)
    "fr": "fr-FR",   // French -> France French (could also be fr-CA for Canada, etc.)
    "de": "de-DE",   // German -> Germany German
    "ru": "ru-RU",   // Russian -> Russia
    "zh": "zh-CN",   // Chinese -> Simplified Chinese for China (could also be zh-TW for Taiwan with Traditional Chinese)
    "ja": "ja-JP",   // Japanese -> Japan
    "ar": "ar-SA",   // Arabic -> Saudi Arabia
    "hi": "hi-IN",   // Hindi -> India
    "pt": "pt-PT",   // Portuguese -> Portugal (could also be pt-BR for Brazil)
    "it": "it-IT",   // Italian -> Italy
    "ko": "ko-KR",   // Korean -> South Korea
    "nl": "nl-NL",   // Dutch -> Netherlands
    "pl": "pl-PL",   // Polish -> Poland
    "sv": "sv-SE",   // Swedish -> Sweden
    "da": "da-DK",   // Danish -> Denmark
    "fi": "fi-FI",   // Finnish -> Finland
    "no": "no-NO",   // Norwegian -> Norway (Bokmål, could also be nn-NO for Nynorsk)
    "el": "el-GR",   // Greek -> Greece
    "tr": "tr-TR",   // Turkish -> Turkey
    "he": "he-IL",   // Hebrew -> Israel
    "id": "id-ID",   // Indonesian -> Indonesia
    "th": "th-TH",   // Thai -> Thailand
    "cs": "cs-CZ",   // Czech -> Czech Republic
    "hu": "hu-HU",   // Hungarian -> Hungary
    "ro": "ro-RO",   // Romanian -> Romania
    "uk": "uk-UA",   // Ukrainian -> Ukraine
    "sk": "sk-SK",   // Slovak -> Slovakia
};

export const TextToSpeechAPI = MyServices["gcp.textToSpeech"]?.url

export const playAudio = ({audioContent, timeout = 1, setLoading}) => {
    const audioBlob = new Blob([new Uint8Array(Buffer.from(audioContent, 'base64'))], { type: 'audio/mp3' });
    const objectURL = URL.createObjectURL(audioBlob);

    const audioElement = document.getElementById('ttsAudio');
    audioElement.src = objectURL;
    audioElement.addEventListener('loadeddata', () => {
        if (audioElement.readyState >= 2) setTimeout(() => audioElement.play(), timeout)
        if (setLoading) setLoading(false)
    });
}

export const fetchAndPlayAudio = async ({setLoading, text, audioContent, languageCode, voice, timeout, KB}) => {
    setLoading(true);
    if (!audioContent && text) {
        const transactionJWT = await signKBTransactionJWT({
            toAccountId: MyServices["gcp.textToSpeech"]?.accountId,
            ...KB,
            message: 'speech generation'})

        if (!languageCode) {
            const language = await detectLanguage(text, KB, 25, 100);
            if (language?.detection?.language && languageToLocaleMap?.[language.detection.language]) {
                languageCode = languageToLocaleMap?.[language.detection.language];
            }
        }

        const payload = {
            text: text,
            sampleRateHertz: 48000,
            speakingRate: '1.2',
            languageCode: languageCode || 'en-US',
            name: voice
        };

        const headers = {
            'Content-Type': 'application/json',
            'transaction-jwt': transactionJWT
        };

        try {
            const response = await APIRequest('post', TextToSpeechAPI, payload, {headers});
            audioContent = Buffer.from(response.data.audioContent, 'base64')
        } catch (error) {
            // console.error('Error fetching audio:', error);
        }
    }


    // Convert base64 audio data to a blob and then to object URL
    playAudio({audioContent, timeout, setLoading})

};

export function TextToSpeechPlayer({ text, audioContent, languageCode, voice, KB, timeout = 1, style = {} }) {
    const [loading, setLoading] = useState();

    if (!text && !audioContent) return;

    return (
        <>
            <IconButton style={style} onClick={() => fetchAndPlayAudio({setLoading, text, audioContent, languageCode, voice, timeout, KB})} aria-label="play speech">
                {loading ? <CircularProgress  size={16} style={style} /> : <VolumeUp  style={style} />}
            </IconButton>
        </>
    );

}
